const { de: globalCommon } = require("../../common");
const { de: plasmidsCommon } = require("../../plasmids-page");

module.exports = {
	...globalCommon,
	...plasmidsCommon,
	"plasmids-plasmid": require("./plasmids-plasmid.json"),
	"section-try-for-free": require("../../section-try-for-free/de/section-try-for-free.json"),
};
